import { FC } from 'react'

import { ConsolidatedShippingCallout } from 'src/components'
import { Shipment } from 'src/types/shipments'

import ShipmentStatusRow from '../ShipmentStatusRow'
import TrackingInfoRow from '../TrackingInfoRow'
import ShipmentAddressRow from '../ShipmentAddressRow'

const isBundled = (shipment: Shipment) =>
  shipment?.consolidationStatus?.consolidated &&
  shipment?.consolidationStatus.type === 'SIMPLE_SHIPPING'

const BundledShippingCalloutRow: FC = () => (
  <ConsolidatedShippingCallout
    learnMoreLink={false}
    text="This gift may be packaged with other items."
    variant="multi-line"
  />
)

const ShipmentDetails: FC<{ shipment: Shipment }> = ({ shipment }) => {
  const { address, shippedToRegistrant } = shipment

  return (
    <>
      <hr />
      {isBundled(shipment) && <BundledShippingCalloutRow />}
      <ShipmentStatusRow shipment={shipment} />
      {shipment.trackingInfos.map((trackingInfo) => (
        <TrackingInfoRow
          key={trackingInfo.number}
          trackingInfo={trackingInfo}
        />
      ))}
      <ShipmentAddressRow
        address={address}
        shippedToRegistrant={shippedToRegistrant}
      />
    </>
  )
}

export default ShipmentDetails
